/**
 * SaveBar — Sticky bottom bar showing unsaved changes indicator with
 * Undo, Discard, and Save buttons. Matches the mockup style exactly.
 */

import React from 'react';
import {
  Box, Typography, IconButton, Button, Tooltip, CircularProgress,
} from '@mui/material';
import { Undo as UndoIcon, Save as SaveIcon } from '@mui/icons-material';

const SaveBar = ({
  isDirty = false,
  canUndo = false,
  saving = false,
  onUndo,
  onDiscard,
  onSave,
}) => {
  if (!isDirty) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        borderTop: '2px solid #ffc107',
        bgcolor: '#fffde7',
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
      }}
    >
      {/* Indicator dot */}
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: '#ffc107',
          flexShrink: 0,
        }}
      />
      <Typography
        variant="caption"
        sx={{ color: '#f57f17', fontWeight: 700, mr: 1 }}
      >
        Unsaved changes
      </Typography>

      <Box sx={{ flexGrow: 1 }} />

      {/* Undo */}
      <Tooltip title="Undo last change">
        <span>
          <IconButton size="small" disabled={!canUndo} onClick={onUndo}>
            <UndoIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      {/* Discard */}
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        sx={{ textTransform: 'none', fontSize: '0.8rem' }}
        onClick={onDiscard}
        disabled={saving}
      >
        Discard Changes
      </Button>

      {/* Save */}
      <Button
        size="small"
        variant="contained"
        startIcon={
          saving ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <SaveIcon sx={{ fontSize: 16 }} />
          )
        }
        sx={{ textTransform: 'none', fontSize: '0.8rem', bgcolor: '#1976d2' }}
        onClick={onSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save Script'}
      </Button>
    </Box>
  );
};

export default SaveBar;
